const base = 'https://www.aloesolbio.com/wp-content/uploads';

export const images = {
  logo: `${base}/2021/09/logo-aloesol-horizontal.svg`,
  logoIcon: `${base}/2021/09/logo-aloesol-icon.png`,
  heroLifestyle: `${base}/2024/06/RAW7686.jpg`,
  lifestyleSecondary: `${base}/2024/06/RAW0734.jpg`,
  lifestyleTowel: `${base}/2024/03/serviette-gel.jpg`,
  campaignBanner: `${base}/2024/07/Banniere-Aloesol-_1_.webp`,
  creme150: `${base}/2024/05/TuboFront150ml.jpg`,
  gel100: `${base}/2024/05/TuboFront100ml.jpg`,
  gel250: `${base}/2024/05/Gel250mlFront.jpg`,
  ecocert: `${base}/2024/03/ecocert_cosmos_organic_logo.webp`,
  cosmebio: `${base}/2024/03/logo-cosmebio-png.png`,
};
